import { LoggedInAction, LoggedOutAction } from '../types/Actions';
import { firebaseUser } from "../firebase";

export const loggedIn = (user: firebaseUser): LoggedInAction => ({
    type: "LOGGED_IN",
    user,
});

export const loggedOut = (): LoggedOutAction => ({
    type: "LOGGED_OUT",
})